import React from 'react'
import { Container, Nav, Navbar, Button } from 'react-bootstrap'
import { Link as ScrollLink } from "react-scroll"; 
import { Link } from "react-router-dom";
import logo from '../assest/images/logo.png';
import '../nav.css';

function Navigation() {
  return (
    <Navbar collapseOnSelect expand="lg" className="custom-navbar">
      <Container>
        <img
          src={logo}
          alt="Hidden Paradise Logo"
          width="150"
          height="70"
          className="d-inline-block align-top me-2"
        />
        <Navbar.Brand href='#'></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            
            <ScrollLink
              to="destinations"
              smooth={true}
              duration={100}
              offset={-70}
              className="nav-link"
              style={{ cursor: "pointer" }}
            >
              Destinations
            </ScrollLink>
            
            <Nav.Link as={Link} to="/about">About</Nav.Link>
            <Nav.Link as={Link} to="/packages">Packages</Nav.Link>

            
            <Button
              as={Link}
              to="/contact"
              variant="outline-warning"
              className="ms-3"
            >
              Get a Quote
            </Button>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Navigation